import { useCallback, useContext, useEffect } from "react"
import ModelElements from "../ModelElements"
import { ProductModelProps } from "../ModelViewerProduct"
import ProductTextureContext from "../_contexts/ProductTextureContext"
import useGLB from "../_hooks/useGLB"
import { FindMaterial } from "../../Common/Utils/ThreeTools"

export default function Tablecloth(props: ProductModelProps) {
    /* Gotta load all the models this way because dynamic paths in URL() aren't picked up by webpack */
    const getUrl = useCallback(() => {
        return {
            '60x60': new URL('@resources/3d-models/glb/tablecloth-60x60.glb', import.meta.url),
            '90x60': new URL('@resources/3d-models/glb/tablecloth-90x60.glb', import.meta.url),
        }[props.variant]
    }, [props.variant])

    const model = useGLB(getUrl() || new URL(''))
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)

    const option_threadColor = props.options.get('thread-color') ?? 'black'
    useEffect(() => {
        let mat = FindMaterial("tablecloth-thread", elements)
        if(mat) mat.color.setHex({
            'white': 0xeeeeee,
            'black': 0x2a2a2a
        }[option_threadColor] as number)
    }, [option_threadColor, elements])

    // Fix/remove transparency
    useEffect(() => {
        if (!elements) return
        for(let mat of [FindMaterial('tablecloth-out', elements), FindMaterial('tablecloth-in', elements)]) {
            if (!mat) continue
            mat.depthWrite = true
            mat.transparent = false
        }
    }, [productTexture, elements])

    // Apply lab texture
    useEffect(() => {
        if (!elements) return
        let mat = FindMaterial('tablecloth-out', elements)
        if (!mat) return
        mat.map = productTexture
        mat.map.flipY = false
        mat.map.needsUpdate = true
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene}/>
}